import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';

const CompListArea = forwardRef((props: any, ref) => {
  let myProps = {
    ...props
  };

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
  }));

  return (
    <div>

    </div>
  );
});
export default CompListArea;